import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ReportingContainerBaseConfig } from '../../../../base';
import {
    CollectionItemController,
    CollectionItemLoader,
} from './collectionItemInterface';
import { CollectionItemContainerProps } from './collectionItemProps';
import { useDisclosure } from '@chakra-ui/react';
import { CollectionItemStateValues } from './collectionItemModel';
import { assert } from '@varos/util-typescript';

export function createCollectionItemContainer(
    config: ReportingContainerBaseConfig & {
        keys: {
            recordUrlParam: string;
        };
    },

    loader: CollectionItemLoader,
    controller: CollectionItemController
): React.FC<CollectionItemContainerProps> {
    const {
        kernel: {
            infra: {
                toaster: { useToast },
            },
        },
        context: { useContext },
        repository: { research: repository },
    } = config;
    return ({ as: View, ...containerProps }) => {
        const context = useContext();
        const toast = useToast();
        const [state, setState] = useState<CollectionItemStateValues>({
            isHovered: false,
        });
        const disclosure = {
            menu: useDisclosure(),
        };
        const [_searchParams, setSearchParams] = useSearchParams();
        const mutation = {
            document: {
                delete: repository.record.useArchive(context),
                create: repository.record.useCreate(context),
            },
        };
        const data = loader.useLoad(context, containerProps);
        const props = controller.useProps(context, data, {
            disclosure,
            hover: {
                value: state.isHovered,
                onChange(value) {
                    setState({ isHovered: value });
                },
            },
            onOpen() {
                setSearchParams((prev) => {
                    prev.set(config.keys.recordUrlParam, data.document.id);
                    return prev;
                });
                disclosure.menu.onClose();
            },
            onCopyLink() {
                console.log('copy link');
                disclosure.menu.onClose();
            },
            async onDuplicate() {
                console.log('duplicate');
                disclosure.menu.onClose();
                assert(data.document.collection, 'expected collection');
                const response = await mutation.document.create.mutateAsync({
                    type: data.document.type ?? 'document',
                    title: data.document.title ?? 'Untitled',
                    collection: data.document.collection,
                    properties: data.document.properties,
                    blocks: [],
                });
                console.log('duplicated', response);
                // TODO show async process that resolves when request finishes
                toast({
                    description: 'Document duplicated successfully',
                    kind: 'success',
                });
            },
            async onDelete() {
                disclosure.menu.onClose();
                console.log('deleting', data.document.id);
                const response = await mutation.document.delete.mutateAsync({
                    contentId: data.document.id,
                });
                console.log('deleted', response);
                // TODO show async process that resolves when request finishes
                toast({
                    description: 'Document deleted successfully',
                    kind: 'info',
                });
            },
        });
        return <View {...props} />;
    };
}
